export const AFFILIATE_CLICK_SCRIPT_URL =
  "https://affiliate.magneticone.com/scripts/clickjs.php";

export const AFFILIATE_SALE_SCRIPT_URL =
  "https://affiliate.magneticone.com/scripts/salejs.php";
